module.exports = __webpack_public_path__ + "static/headshot-forest-monsen-2x.f27a988b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-forest-monsen-2x.jpg
// module id = 519
// module chunks = 152909308826437